import BezierEasing from 'bezier-easing';
export const EXPAND = BezierEasing(0, 0.1, 0.5, 0);
export const EXPANDED = 'EXPANDED';
export const EXPANDING = 'EXPANDING';
export const COLLAPSE = BezierEasing(0, 0.5, 0, 0);
export const DURATION = 320;
